import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    "@type": "ListItem" as const,
    position: index + 1,
    item: item.href
      ? { "@id": `https://feimagua.com${item.href}`, name: item.label }
      : { name: item.label },
  }));

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: schemaItems,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-xs text-foreground-500">
          {items.map((item, index) => (
            <li key={index} className="flex items-center whitespace-nowrap">
              {index > 0 && (
                <span className="mx-1.5 text-foreground-400">/</span>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-500 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}